import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"
import {CourseProgressById} from "../apiConfigs"

export const CourseProgressByIdApi = createAsyncThunk(
    'auth/analytics/CourseProgressByIdApi',
    async (requestData, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.get(CourseProgressById, { params: requestData })
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

const CourseProgressByIdSlice = createSlice({
    name: 'analytics/CourseProgressByIdApi',
    initialState: { result: [], loading: false, error: null, message: "", total: 0 },
    extraReducers: (builder) => {
        builder.addCase(CourseProgressByIdApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(CourseProgressByIdApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
            state.total = action?.payload?.count
        })
        builder.addCase(CourseProgressByIdApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const CourseProgressByIdReducer = CourseProgressByIdSlice.reducer